import { useIntl } from 'react-intl';
import { getConfig } from '@src/config';
export function useConfig() {
    const intl = useIntl();
    const config = getConfig(intl.locale);
    return config;
}
